import { getAllModulesInitActions, getSectionLayoutInitAction } from './common';

export function getHomeSectionInitActions(responseData) {
  const isMobile =
    responseData.session.device && responseData.session.device.isMobile;
  // for desktop, this was originally 4 but init/home uses the default comment maxDepth
  // of 4 on the backend (because we can't send it in the api call), so we need
  // `maxDepth - 1` on the frontend in order to show the 'view more replies'
  const commentMaxDepth = isMobile ? 2 : 3;
  const params = { commentMaxDepth };
  return [
    getSectionLayoutInitAction(responseData, 'home'),
    ...getAllModulesInitActions(responseData, params),
  ].filter(action => action);
}
